import store from '../store/index.js';
import Vue from 'vue'
import formData from '../../static/formList.json'
Date.prototype.Format = function (fmt) { //格式化时间
    var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + ""));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};
window.log = console.log;
window.download = function (url, name) {
    const a = document.createElement('a'); // 创建a标签
    a.setAttribute('download', name);// download属性
    a.setAttribute('href', url);// href链接
    a.click();// 自执行点击事件
}

const fun = {
    getForm(title) {
        let data
        formData.forEach(it => {
            if (it.title === title) {
                data = it.data
                return
            }
        })
        return data
    },

}

export const vm = new Vue

export default fun


